const style = {
  organizationSitesTable__cell_action: {
    paddingLeft: '10px',
  },
  tableBody: {},
};

export default style;
